import { Checkbox, Label, Stack, StackItem } from '@fluentui/react';
import { useConfigValuesState } from '../../../../../hooks/useConfigValue';
import { useCallback } from 'react';

export const WorkdaySelector = () => {
    const {
        initialData: {
            configuration: { weekConfig },
        },
        setConfigValue,
    } = useConfigValuesState();
    const setDay = useCallback(
        (dayIndex: number, enabled: boolean) => {
            setConfigValue(config => {
                return {
                    ...config,
                    weekConfig: config.weekConfig.map((day, i) => {
                        if (i === dayIndex) {
                            return {
                                ...day,
                                enabled,
                            };
                        }
                        return day;
                    }),
                };
            });
        },
        [setConfigValue],
    );

    return (
        <Stack>
            <StackItem>
                <Label>Work days</Label>
            </StackItem>
            <Stack horizontal>
                {weekConfig.map((day, i) => {
                    return (
                        <Checkbox
                            styles={{ label: { paddingRight: 6 } }}
                            key={day.name}
                            label={day.name}
                            checked={day.enabled}
                            onChange={(e, checked) => setDay(i, checked)}
                        />
                    );
                })}
            </Stack>
        </Stack>
    );
};
